<template lang="html">
    <button v-bind:style="'border-radius: ' + radius + 'px'" v-bind:class="classes" v-on:click="onClick"><slot></slot></button>
</template>
<script>
    export default {
        name: 'z-button',
        props: {
            radius: {
                type: Number,
                default: 3
            },
            uppercase: {
                type: Boolean,
                default: true
            },
            thin: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            },
            square: {
                type: Boolean,
                default: false
            },
            accent: {
                type: Boolean,
                default: false
            },
            success: {
                type: Boolean,
                default: false
            },
            primary: {
                type: Boolean,
                default: false
            },
            danger: {
                type: Boolean,
                default: false
            },
            successLight: {
                type: Boolean,
                default: false
            },
            primaryLight: {
                type: Boolean,
                default: false
            },
            dangerLight: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            fitContent: {
                type: Boolean,
                default: false
            },
            noMargin: {
                type: Boolean,
                default: false
            },
            transperent: {
                type: Boolean,
                default: false
            }                       
        },
        computed: {
            classes() {
                return {
                    'z-button': true,
                    'fit-content': this.$props.fitContent,
                    'no-margin': this.$props.noMargin,
                    'transperent': this.$props.transperent,
                    uppercase: this.$props.uppercase,
                    thin:   this.$props.thin,
                    accent: this.$props.accent,
                    light:  this.$props.light,
                    square: this.$props.square,
                    'disabled': !!this.$props.disabled,
                    'success': !!this.$props.success,
                    'primary': !!this.$props.primary,
                    'danger':  !!this.$props.danger,
                    'success-light': !!this.$props.successLight,
                    'primary-light': !!this.$props.primaryLight,
                    'danger-light':  !!this.$props.dangerLight
                };
            }
        },
        methods: {
            onClick(e) {
                if (this.$props.disabled) return;
                this.$emit('click', e);
            }
        }
    }
</script>
<style lang="sass">
    .z-button
        cursor: pointer
        font-size: 12px
        display: flex
        align-items: center
        justify-content: center
        font-weight: 500
        border: 0
        height: var(--a-icon-size-x45)
        margin: var(--margin-x1)
        padding: 0 var(--margin-x2)
        transition: all .2s
        font-family: inherit
        width: 100%
        background: var(--color-primary-500)
        color: var(--color-secondary-100)

        &.disabled
            opacity: 0.5
            cursor: not-allowed

        .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
            color: #fff
        &:hover, &:active
            background: var(--color-primary-800)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: #fff

        &.fit-content
            width: fit-content

        &.no-margin
            margin: 0

        &.uppercase
            text-transform: uppercase

        &.thin
            height: var(--a-icon-size-x35)
            
        &.square
            width: var(--a-icon-size-x45)

        &.square.thin
            width: var(--a-icon-size-x35)
            height: var(--a-icon-size-x35)

        &.success-light
            background: var(--color-success-100)
            color: var(--color-success-900)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-success-900)
            &:hover, &:active
                background: var(--color-success-200)

        &.primary-light
            background: var(--color-primary-100)
            color: var(--color-primary-900)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-primary-900)
            &:hover, &:active
                background: var(--color-primary-200)

        &.danger-light, &.light.accent
            background: var(--color-danger-100)
            color: var(--color-danger-900)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-danger-900)
            &:hover, &:active
                background: var(--color-danger-200)


        &.success
            background: var(--color-success-500)
            color: var(--color-secondary-100)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-success-800)

        &.primary
            background: var(--color-primary-500)
            color: var(--color-secondary-100)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-primary-800)

        &.danger, &.accent
            background: var(--color-danger-500)
            color: var(--color-secondary-100)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-danger-800)
        
        &.transperent
            background: transparent
            color: var(--color-primary-500)
            .z-icon, i, .md-icon, .md-icon.md-theme-white.md-icon-font
                color: var(--color-secondary-600)
            &:hover, &:active
                background: var(--color-primary-100)

        .md-icon.md-theme-default.md-icon-font
            color: #fff
            font-size: 16px !important
            width: 16px
            height: 16px
            min-width: auto
</style>



// WEBPACK FOOTER //
// ZButton.vue?763772fa